<script lang="js">
import Modal from "@/components/g-modal.vue";
import Table from "@/components/table-v.vue";

export default {
  components: {
    Modal,
    Table
  },
  props: {
    opened: Boolean,
    data: { type: Array, default: () => [] },
    title: { type: String, required: true },
    columns: { type: Array, required: true },
    // Mostra o ícone de editar por linha (restrito a administrador pelo
    // componente pai — este componente só emite `edit`/`delete`, quem chama
    // decide se pode mostrar e o que fazer com a linha).
    canManage: { type: Boolean, default: false },
    // Mostra o ícone de excluir por linha, independente de `canManage` (nem
    // todo consumidor tem uma rota de exclusão de registro específico).
    canDelete: { type: Boolean, default: false }
  },
  model: {
    event: "update:opened",
    prop: "opened"
  },
  computed: {
    cols() {
      // `sortable: false` em todas as colunas: a ordem é sempre a do
      // histórico (mais recente primeiro, ver `rows` abaixo), não uma
      // ordenação livre por coluna que poderia invertê-la.
      return [
        ...this.columns.map(col => ({
          key: col.key,
          name: col.name,
          type: col.type || this.$fieldTypes.TEXT,
          sortable: false
        })),
        {
          key: "competencia_inicio",
          name: "Competência inicial",
          type: this.$fieldTypes.MONTH,
          align: 1,
          sortable: false
        },
        {
          key: "competencia_fim",
          name: "Competência final",
          type: this.$fieldTypes.MONTH,
          align: 1,
          sortable: false
        },
        ...(this.canManage || this.canDelete ? [{ key: "actions", name: "", align: 1, sortable: false }] : [])
      ];
    },
    rows() {
      const list = this.data ?? [];
      // Um `competencia_fim` nulo é o vínculo vigente (ainda não encerrou),
      // então vale como a data mais recente possível no desempate — não
      // como a mais antiga (senão o vigente cairia pro fim da lista quando
      // empatar em `competencia_inicio` com um registro já encerrado).
      const sorted = [...list].sort((a, b) => {
        const dateAInicio = a.competencia_inicio || "0000-00";
        const dateBInicio = b.competencia_inicio || "0000-00";
        const dateAFim = a.competencia_fim || "9999-99";
        const dateBFim = b.competencia_fim || "9999-99";

        if (dateBInicio !== dateAInicio) {
          return dateBInicio.localeCompare(dateAInicio);
        }
        return dateBFim.localeCompare(dateAFim);
      });

      return sorted.map(original => {
        const { competencia_inicio, competencia_fim, ...rest } = original;

        return {
          ...rest,
          competencia_inicio: competencia_inicio || "Indefinido",
          competencia_fim: competencia_fim || "Indefinido",
          // Item original (com os valores reais, não "Indefinido"), pra
          // `edit`/`delete` não vazarem o texto de exibição pro formulário.
          _original: original
        };
      });
    }
  }
};
</script>

<template>
  <Modal
    noPadding
    :opened="opened"
    :title="title"
    @update:opened="$emit('update:opened', $event)"
  >
    <Table :cols="cols" disablePagination :rows="rows">
      <template v-if="canManage || canDelete" v-slot:item.actions="{ item }">
        <v-btn v-if="canManage" icon title="Editar" @click="$emit('edit', item._original)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn v-if="canDelete" icon title="Excluir" @click="$emit('delete', item._original)">
          <v-icon small color="error">mdi-delete</v-icon>
        </v-btn>
      </template>
    </Table>
  </Modal>
</template>
